package dev.valvassori.ext

import androidx.compose.web.events.SyntheticMouseEvent

val SyntheticMouseEvent.isRightClick: Boolean
    get() = nativeEvent.asDynamic().which === 3
